<div *ngIf="display" class="evt-spinner-overlay bg-dark">
  <!-- loading spinner -->
  <div class="evt-spinner-overlay-body text-center text-light">
    <app-spinner size="l"></app-spinner>
    <p class="mt-2">{{'LOADING'|translate}}</p>
  </div>
</div>